import API from "@/api";

//上传配置

export default {
	apiObj: API.common.upload,			//上传请求API对象
	filename: "files",					//form请求时文件的key
	successCode: 200,					//请求完成代码
	maxSize: 10,						//最大文件大小 默认10MB
	parseData: function (res) {
		if(res){
			return {
				code: 200,				//分析状态字段结构
				fileName: res[0].fileUrl,//分析文件名称
				src: res[0].downFileUrl,			//分析图片远程地址结构
				msg: res.msg,			//分析描述字段结构
				fileId:res[0].fileUrl,
			}
		}else{
			return {
				
			}
		}
		
	},
	apiObjFile: API.common.upload,	//附件上传请求API对象
	maxSizeFile: 500						//最大文件大小 默认10MB
}
